import {
    getLineDetail,
    getCirDetail,
    getSqDetail,
    getLandingpointDetail
} from "../request/api";

import { mapActions, mapMutations } from "vuex";
export default {
    methods: {
        ...mapMutations({
            startDataDrawAction: "drawMap/startDataDraw",
            stopDrawAction: "drawMap/stopDraw",
        }),
        ...mapActions({
            initEchrtMap: "echartsMap/initEchrtMapAction",
        }),
        async detailLine(id) {
            let res = await getLineDetail(id);
            if (res.code !== 200) {
                return;
            }
            let latlngs = [];
            res.route.routepoints.forEach((item) => {
                let latlng = [item.la, item.lo];
                latlngs.push(latlng);

                this.startDataDrawAction(L.circleMarker([item.la, item.lo], {
                    pane: 'dash',
                    radius: 5,
                    opacity: 0.3,
                    className: 'lineTooltip',
                    color: "#66d9ef",
                    fillColor: '#66d9ef',
                    fillOpacity: 1
                }).bindTooltip(`${item.title},${item.la}, ${item.lo}`));
            });
            var drawLayer = new L.Polyline.AntPath(latlngs, {
                color: "#57c9f3",
                delay: 200,
                dashArray: [10, 20],
                weight: 5,
                paused: false,
                reverse: false,
                hardwareAccelerated: true,
            });

            let firpot = [...latlngs[0]].reverse();
            let endpot = [...latlngs[latlngs.length - 1]].reverse();
            drawLayer.bindTooltip(res.route.title, {
                pane: 'dash',
                permanent: true
            })

            // this.initEchrtMap({ firpot, endpot });

            this.startDataDrawAction(drawLayer);
            return res.route
        },
        async detailHomeLine(id) {
            let res = await getLineDetail(id);
            if (res.code !== 200) {
                return;
            }
            let latlngs = [];
            res.route.routepoints.forEach((item) => {
                let latlng = [item.la, item.lo];
                latlngs.push(latlng);
            });
            var drawLayer = new L.Polyline(latlngs, {
                color: '#57c9f3',
                delay: 300,
                dashArray: [10, 20],
                weight: 5,
                paused: false,
                reverse: false,
                hardwareAccelerated: true,
            });
            this.startDataDrawAction(drawLayer);
            return res.route
        },
        async detailCir(id) {
            let res = await getCirDetail(id);
            if (res.code !== 200) {
                return;
            }
            let radius = res.roundarea.radius * 1000;
            var drawLayer = L.circle([res.roundarea.la, res.roundarea.lo], {
                color: "#57c9f3",
                radius,
            });
            console.log(res);
            var c = L.circleMarker([res.roundarea.la, res.roundarea.lo], {
                radius: 0,
                labelStyle: {
                    text: res.roundarea.title,
                    scale: 1.4,
                    fillStyle: "#fff",
                    strokeStyle: "#fff",
                },
                color: "rgba(255,255,225,0)",
                opacity: 0.5,
            })
            console.log(drawLayer);
            this.startDataDrawAction(drawLayer);
            this.startDataDrawAction(c);
            return res.roundarea
        },
        async detailSq(id) {
            let res = await getSqDetail(id);
            if (res.code !== 200) {
                return;
            }
            let latlngs = [];
            res.polygonarea.polygonpoints.forEach((item) => {
                let latlng = [item.la, item.lo];
                latlngs.push(latlng);
            });
            var drawLayer = L.polygon(latlngs, {
                color: "#57c9f3",
            });

            var c = L.circleMarker(latlngs[0], {
                radius: 0,
                labelStyle: {
                    text: res.polygonarea.title,
                    scale: 1.4,
                    fillStyle: "#fff",
                    strokeStyle: "#fff",
                },
                color: "rgba(255,255,225,0)",
                opacity: 0.5,
            })


            this.startDataDrawAction(drawLayer);
            this.startDataDrawAction(c);
            return res.polygonarea
        },
        async detailLanding(id) {
            let res = await getLandingpointDetail(id);
            if (res.code !== 200) {
                return;
            }
            var CustomerIcon = L.Icon.extend({
                options: {
                    // 图标图片的地址
                    iconUrl: process.env.BASE_URL + "/image/up.png",
                    // 图标阴影的地址
                    // shadowUrl: "../../images/new/xiaofangdiliweizhi.svg",
                    // 图标大小
                    iconSize: [45, 45],
                    // 图标偏离的位置
                    shadowSize: [50, 64],
                    // 图标阴影的大小
                    iconAnchor: [20, 65],
                },
            });
            var drawLayer = L.marker([res.landingpoint.la, res.landingpoint.lo], {
                title: "这是一个起降点",
                icon: new CustomerIcon(),
            });

            this.startDataDrawAction(drawLayer);
            this.flyAction([res.landingpoint.la, res.landingpoint.lo]);
            return res.landingpoint
        },
    }
}